import React from 'react';
import MUIGrid from '@mui/system/Unstable_Grid';

import { GridProps } from './Grid.types';
import { SxProps, Theme } from '@mui/system';

const Row = React.forwardRef(
  (
    { children, sx, className, ...props }: GridProps,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    return (
      <MUIGrid
        className={`cms-row ${className}`}
        ref={ref}
        container
        columns={24}
        spacing={{ xs: '0.4rem', sm: '0.8rem', md: '1.6rem' }}
        sx={sx as SxProps<Theme>}
        {...props}
      >
        {children}
      </MUIGrid>
    );
  },
);

export default Row;
